// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: "Lato", sans-serif;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color:ed;
  z-index: -1;
  opacity: 0;
  transition: 1s all;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  padding: 0px 70px;  
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  margin-left: 60px;
  border-radius: 30px;
 
}

.logoo
{
  height:35px;
  width:100px;
}
.down
{
  width: 10px;
  height:10px;
}
.down1
{
  width: 20px;
  height:20px;
}
.navbar-links {
  list-style-type: none;
  display: flex;
  gap: 20px;
}
.navbar-links li a {
  display: block;
  text-decoration: none;
  color: white;
  padding: 20px 20px;
  font-weight: 700;
  transition: 0.4s all;
}

.navbar-links li.navbar-dropdown {
  position: relative;
}

.navbar-links li.navbar-dropdown:hover .dropdown {
  visibility: visible;
  opacity: 1;
  transform: translateY(0px);
}

.navbar-links li.navbar-dropdown .dropdown {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  padding: 20px 0;
  top: 100%;
  transform: translateY(50px);
  left: 0;
  border-radius: 2px;
  width: 230px;
  /* background-color: #fff; */
  box-shadow: 0px 10px 10px 3px rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  z-index: 111;
  transition: 0.4s all;

  
}
.navbar-links li.navbar-dropdown .dropdown a {
  padding-top:0px;
  padding-bottom: 0px;
  font-weight: 400;
  color: white;
  cursor: pointer;
}



.dropdown_link{
  display: flex;
  align-items: center;
  padding-top:10px;
  padding-bottom: 10px;
}
.dropdown_link:hover{
  /* padding-left: 30px; */
  background-color: #642bff;
  color: white;
  /* margin: 10px; */
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
  transition: 0.4s all;
}
.navbar-links li a:hover {
  color: #642bff;
}
h1
{
  display: inline;
}

.button-div{
    
  width:200px;
  height:30px;
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius:7px;
  padding:7px;
  gap:20px
}
.signup-button{
  cursor: pointer;
  background: radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%);
  /* backdrop-filter: blur(10px); */
  border-radius: 20px;
}

.login-button{
  cursor: pointer;
  border-radius: 20px;
}


.login-button:hover{
  
  background:transparent;
  border: 2px solid #642bff;
  color: white;
}
.logo-title{
  color: white;
  margin: 0px;
}


.signup-button:hover{
   color:white;
  background-color:#642bff;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;EACjB,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;;EAEE,WAAW;EACX,WAAW;AACb;AACA;;EAEE,WAAW;EACX,WAAW;AACb;AACA;;EAEE,WAAW;EACX,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,gDAAgD;EAChD,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;;;AAGtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX;AACF;AACA;EACE,eAAe;EACf,qFAAqF;EACrF,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA;GACG,WAAW;EACZ,wBAAwB;AAC1B","sourcesContent":["* {\r\n  padding: 0;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: \"Lato\", sans-serif;\r\n}\r\n\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color:ed;\r\n  z-index: -1;\r\n  opacity: 0;\r\n  transition: 1s all;\r\n}\r\n\r\n.navbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 90%;\r\n  padding: 0px 70px;  \r\n  background: rgba(255, 255, 255, 0.1);\r\n  backdrop-filter: blur(10px);\r\n  margin-left: 60px;\r\n  border-radius: 30px;\r\n \r\n}\r\n\r\n.logoo\r\n{\r\n  height:35px;\r\n  width:100px;\r\n}\r\n.down\r\n{\r\n  width: 10px;\r\n  height:10px;\r\n}\r\n.down1\r\n{\r\n  width: 20px;\r\n  height:20px;\r\n}\r\n.navbar-links {\r\n  list-style-type: none;\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n.navbar-links li a {\r\n  display: block;\r\n  text-decoration: none;\r\n  color: white;\r\n  padding: 20px 20px;\r\n  font-weight: 700;\r\n  transition: 0.4s all;\r\n}\r\n\r\n.navbar-links li.navbar-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.navbar-links li.navbar-dropdown:hover .dropdown {\r\n  visibility: visible;\r\n  opacity: 1;\r\n  transform: translateY(0px);\r\n}\r\n\r\n.navbar-links li.navbar-dropdown .dropdown {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  position: absolute;\r\n  padding: 20px 0;\r\n  top: 100%;\r\n  transform: translateY(50px);\r\n  left: 0;\r\n  border-radius: 2px;\r\n  width: 230px;\r\n  /* background-color: #fff; */\r\n  box-shadow: 0px 10px 10px 3px rgba(0, 0, 0, 0.3);\r\n  border-bottom-left-radius: 3px;\r\n  border-bottom-right-radius: 3px;\r\n  z-index: 111;\r\n  transition: 0.4s all;\r\n\r\n  \r\n}\r\n.navbar-links li.navbar-dropdown .dropdown a {\r\n  padding-top:0px;\r\n  padding-bottom: 0px;\r\n  font-weight: 400;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n\r\n.dropdown_link{\r\n  display: flex;\r\n  align-items: center;\r\n  padding-top:10px;\r\n  padding-bottom: 10px;\r\n}\r\n.dropdown_link:hover{\r\n  /* padding-left: 30px; */\r\n  background-color: #642bff;\r\n  color: white;\r\n  /* margin: 10px; */\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  border-radius: 10px;\r\n  transition: 0.4s all;\r\n}\r\n.navbar-links li a:hover {\r\n  color: #642bff;\r\n}\r\nh1\r\n{\r\n  display: inline;\r\n}\r\n\r\n.button-div{\r\n    \r\n  width:200px;\r\n  height:30px;\r\n  display:flex;\r\n  justify-content:center;\r\n  align-items:center;\r\n  border-radius:7px;\r\n  padding:7px;\r\n  gap:20px\r\n}\r\n.signup-button{\r\n  cursor: pointer;\r\n  background: radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%);\r\n  /* backdrop-filter: blur(10px); */\r\n  border-radius: 20px;\r\n}\r\n\r\n.login-button{\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n}\r\n\r\n\r\n.login-button:hover{\r\n  \r\n  background:transparent;\r\n  border: 2px solid #642bff;\r\n  color: white;\r\n}\r\n.logo-title{\r\n  color: white;\r\n  margin: 0px;\r\n}\r\n\r\n\r\n.signup-button:hover{\r\n   color:white;\r\n  background-color:#642bff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
